import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Lottie from "react-lottie-player";
import errorAnimation from "../assets/failureanimation.json";
import "./orderstyles.css";

const NotFoundPage = () => {
    const [lang, setLang] = useState("en");

    useEffect(() => {
        const storedLang = localStorage.getItem("userLang");
        if (storedLang) {
            setLang(storedLang);
        }
    }, []);

    const message = lang === "th"
        ? "ขออภัย! หน้าที่คุณกำลังค้นหาไม่อยู่ที่นี่."
        : "Oops! The page you're looking for doesn't exist.";

    const buttonText = lang === "th"
        ? "กลับไปหน้าหลัก"
        : "Go Back to Home";

    return (
        <div className="not-found-container">
            <Lottie
                loop
                animationData={errorAnimation}
                play
                style={{ width: 250, height: 250 }}
            />
            <h1 className="not-found-title">404</h1>
            <p className="not-found-message">{message}</p>
            <Link to="/" className="go-back-button">
                {buttonText}
            </Link>
        </div>
    );
};

export default NotFoundPage;
